import React, { useContext } from "react";
import { Checkbox } from "@mui/material";
import { ForwardMessageContext } from "../../context/ForwarMessage/ForwardMessageContext";

const SelectMessageCheckbox = ({ message }) => {
    const { showSelectMessageCheckbox,
      setSelectedMessages,
      selectedMessages,
   } = useContext(ForwardMessageContext);

    // O estado marcado vem da própria seleção (antes era um estado local que não voltava a
    // "desmarcado") e a lista é trocada por uma nova, sem alterar a do contexto no lugar.
    const isChecked = selectedMessages.some((m) => m.id === message.id);

    const handleSelectMessage = (e) => {
        if (e.target.checked) {
          if (!isChecked) setSelectedMessages([...selectedMessages, message]);
        } else {
          setSelectedMessages(selectedMessages.filter((m) => m.id !== message.id));
        }
      }

    if (showSelectMessageCheckbox) {
        // fica ao lado do balão (como no WhatsApp), não dentro dele
        return (
          <span style={{ position: "absolute", left: -40, top: "50%", transform: "translateY(-50%)" }}>
            <Checkbox
              color="primary"
              size="small"
              checked={isChecked}
              onChange={handleSelectMessage}
              inputProps={{ "aria-label": "Selecionar mensagem" }}
            />
          </span>
        );
    } else {
        return null;
    }
}

export default SelectMessageCheckbox;
